/* eslint-disable react/require-default-props */
import {
    TablePaginationProps,
} from '@mui/material/TablePagination'
import {
    gridPaginationRowCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid-pro'
import SkyNetPagination, {
    SkyNetPaginationMode,
} from 'app/shared-components/SkyNetPagination'

function SkyNetDataGridPagination({
    className,
    mode = SkyNetPaginationMode.NUMERICAL,
    useCard = false,
    rowsPerPage = 25,
    showAlways = false,
}: Pick<TablePaginationProps, 'className'> & {
    mode?: SkyNetPaginationMode,
    useCard?: boolean,
    rowsPerPage?: number,
    showAlways?: boolean,
}) {
    const apiRef = useGridApiContext()
    const page = useGridSelector(apiRef, gridPageSelector)
    const total = useGridSelector(apiRef, gridPaginationRowCountSelector)

    return (
        <div className={className}>
            <SkyNetPagination
                total={total}
                rowsPerPage={rowsPerPage}
                page={page + 1}
                mode={mode}
                useCard={useCard}
                onChange={(event, newPage) => {
                    apiRef.current.setPage(newPage - 1)
                }}
                showAlways={showAlways}
            />
        </div>
    )
}

export default SkyNetDataGridPagination
